import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehiclePart } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontBumperImg from '../../assets/images/car-model/front_bumper.png';
import RearBumperImg from '../../assets/images/car-model/rear_bumper.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
}

const BUMPER_IMGS = {
  [VehiclePart.Front]: FrontBumperImg,
  [VehiclePart.Rear]: RearBumperImg,
};

class VehicleBumper extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.part}-bumper`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, part, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={BUMPER_IMGS[part]}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleBumper = styled(VehicleBumper)`
  position: relative;
  width: 8em;
`;

export default StyledVehicleBumper;
